import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ToastController} from 'ionic-angular';

import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {SubscriptionServerProvider} from '../../providers/subscription-server/subscription-server';
import {NewSubscriptionProvider} from '../../providers/new-subscription/new-subscription';
import {NewSubscriptionStep2Page} from "../new-subscription-step2/new-subscription-step2";
import {AlertProvider} from "../../providers/alert/alert";

import {NewSubscription} from '../../models/newsubscription';
//import {resolveAny} from "dns";
import * as _ from 'lodash';

/**
 * Generated class for the NewSubscriptionStep1Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-new-subscription-step1',
  templateUrl: 'new-subscription-step1.html',
})
export class NewSubscriptionStep1Page {

  public loading: boolean = false;
  public newSubscription: NewSubscription;
  public proofs: any[] = [];
  public proof: any = {
    id: 0,
    name: '',
    validity: 0,
    description: '',
    availabilities: []
  };
  public error: boolean = false;
  public errorMessage: string = null;
  public modalityId: number = 4;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private networkMonitor: NetworkMonitorProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private subscriptionServerProvider: SubscriptionServerProvider,
    private newSubscriptionProvider: NewSubscriptionProvider,
    private platform: Platform,
    private alertProvider: AlertProvider,
  ) {
    this.newSubscription = new NewSubscription();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewSubscriptionStep1Page');
  }

  ionViewWillEnter() {
    let loader = this.loadingCtrl.create({
      content: 'Obtendo as inscrições...',
    });
    loader.present();
    this.loading = true;

    let that = this;
    this.proofs = [];

    this.subscriptionServerProvider.fetchProofsThatCanCreate(this.modalityId).subscribe((proofs: any) => {
      if ((proofs) && (proofs.error)) {
        that.error = true;

        if (proofs.errorMessage) {
          that.errorMessage = proofs.errorMessage;
        }
      }
      try {
        _(proofs).forEach((proof: any) => {
          that.proofs.push(proof);
        });

        console.log(that.proofs);
      } catch (ex) {
        that.doNotRetrivedProofs(ex);
      }
      loader.dismiss();
      that.loading = false;
    }, (error: any) => {
      loader.dismiss();
      that.loading = false;
      that.doNotRetrivedProofs(error);
    });
  }

  private doNotRetrivedProofs(error = null) {
    this.proofs = [];
    console.log('Não foi possível obter as provas disponíveis.', error);
    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter as provas disponíveis.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onNext(proofTypeId: any, proofType: string) {
    this.navCtrl.push(NewSubscriptionStep2Page, {
      proofTypeId: proofTypeId,
      proofType: proofType,
      animation: 'ios-transition'
    });
  }

  selectType(proofId: any, proofName: string, kind: string) {
    this.newSubscription.proofId = proofId;
    this.newSubscription.proofName = proofName;
    // NEW - New Subscription
    // RNW - Renew Subscription
    // RNV - Renovation Subscription
    this.newSubscription.kind = kind;

    console.log('Tipo newSubscription--->', this.newSubscription);
    let message = null;
    // DONE: On mobile HTML tag on message do not work
    if (this.platform.is('cordova')) {
      message = 'Você confirma a escolha da ' + this.newSubscription.proofName + '?';
    } else {
      message = 'Você confirma a escolha da <strong>' + this.newSubscription.proofName + '</strong>?';
    }
    this.alertProvider.doConfirm(message, () => {
      this.newSubscriptionProvider.saveDataAndGoToPage(this.newSubscription,
        NewSubscriptionStep2Page);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/new-subscription-step1/new-subscription-step1.ts